export function addErrorClass (elemId, customText = null) {
  let elem = document.getElementById(elemId)
  elem.classList.add('has-error')
  const inputChild = elem.querySelector('input')
  if (!inputChild) {
    return
  }
  inputChild.value = ''
  const text = customText || 'Это поле обязательно для заполнения'
  inputChild.placeholder = text || null
}

export function removeErrorClass (elemId) {
  let elem = document.getElementById(elemId)
  elem.classList.remove('has-error')
  elem.querySelector('input') ? elem.querySelector('input').placeholder = '' : null
}

export function getActualDateInDatetime () {
  const date = new Date().toLocaleString('sv');
  return date;
}

export function generateRandomString() {
  return (Math.random() + 1).toString(36).substring(7)
}

export const convertToBase64 = (file) => (
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
  })
)

export const getPagesCounter = (totalItems = 10, onPage = 20) => {
  const itemsOnPage = onPage;
  const results = Math.ceil(totalItems / itemsOnPage);
  return results;
};

export const getPaginationRange = (start, end) => {
  let length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};

export const camelToSnakeCase = (str) => (
  str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
);

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validateUrl = (url = '') => {
  const urlPattern = new RegExp('^(https?:\\/\\/)?'+
	  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+
	  '((\\d{1,3}\\.){3}\\d{1,3}))'+
	  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+
	  '(\\?[;&a-z\\d%_.~+=-]*)?'+
	  '(\\#[-a-z\\d_]*)?$','i');
	return !!urlPattern.test(url);
};

export const getFutureTimestamp = (minutes = 30) => {
  let timestamp = new Date().getTime() / 1000;
  timestamp += minutes * 60;
  return timestamp;
};

export const capitalizeFirstLetter = (string) => (
  string.charAt(0).toUpperCase() + string.slice(1)
)

export const getRandomArbitrary = (min, max) => (
  Math.random() * (max - min) + min
);



// WEBPACK FOOTER //
// ./src/services/utils.js